function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

export { isValidEmail, isValidMobileLandNumber, isValidMobileNumber, isValidAlphaWithSpace, isValidNric } from './validations';
export { getAllCookies, getJsonCookie, setCookie, setJsonCookie } from './cookie';
export function remCalc(px) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var forcePortable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof __PORTABLE_LUX__ !== 'undefined' && __PORTABLE_LUX__ || forcePortable) {
    return px + 'px';
  } else {
    return px / base + 'rem';
  }
}
export function hexToRGBA(hex) {
  var _hex = hex.replace('#', '');

  return {
    r: parseInt(_hex.slice(0, 2), 16),
    g: parseInt(_hex.slice(2, 4), 16),
    b: parseInt(_hex.slice(4, 6), 16),
    a: parseInt(_hex.slice(6, 8).length === 0 ? 'FF' : _hex.slice(6, 8), 16)
  };
}
export function rgbaToHex(rgba, withHash) {
  var hex = [Number(rgba.r).toString(16), Number(rgba.g).toString(16), Number(rgba.b).toString(16), Number(rgba.a).toString(16)].map(function (item) {
    return item.length === 1 ? '0' + item : item;
  });
  return (withHash ? '#' : '') + hex.join('').toUpperCase();
}
export function adjustContrast(colour, amount) {
  var r = parseInt(colour.r + colour.r / 100 * (1 + amount));
  var g = parseInt(colour.g + colour.g / 100 * (1 + amount));
  var b = parseInt(colour.b + colour.b / 100 * (1 + amount));
  return {
    r: r < 256 ? r : 255,
    g: g < 256 ? g : 255,
    b: b < 256 ? b : 255,
    a: colour.a
  };
}
export function getUrlParams() {
  var searchString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  var hashes = /[?&]/.test(searchString) ? searchString.slice(searchString.indexOf('?') + 1).split('&') : [];
  return hashes.filter(function (hash) {
    return hash;
  }).reduce(function (accum, hash) {
    var _hash$split = hash.split('='),
        _hash$split2 = _slicedToArray(_hash$split, 2),
        key = _hash$split2[0],
        val = _hash$split2[1];

    accum[key] = val && decodeURIComponent(val) || '';
    return accum;
  }, {});
}
export function setUrlParams(url, params) {
  var urlWithoutHash = url.split('#')[0];
  var urlHash = url.split('#')[1];
  var paramsWithExisting = Object.assign(getUrlParams(urlWithoutHash), params);
  var newParams = Object.keys(paramsWithExisting).map(function (key) {
    return [key, paramsWithExisting[key]].map(encodeURIComponent).join('=');
  }).join('&');
  var hashString = urlHash ? "#".concat(urlHash) : '';
  return [urlWithoutHash.split('?')[0], newParams].join('?') + hashString;
}
export function isEnterKey(e) {
  return e.which === 13 || e.keyCode === 13 || e.key === 13;
}
export function isUrlAbsolute(url) {
  return url.indexOf('://') > 0 || url.indexOf('//') === 0;
}
export function noop() {}